class Api {
    constructor() {
        /*
        fetch('./json/config.json')
            .then(response => response.json())
            .then((json) => {
                //console.log('config json', json);
                this.baseUrl = json.server;
            });
        */
        //this.language = VueCookies.get('language') || 'SK';
        //this.language = this.getCookie("language") || 'SK';
        //this.strings = {};
        //this.loadStrings(this.language);
        //return this.strings;
    }

    setConfig(input) {
        this.baseUrl = input.server;
        this.stringsUrl = input.stringsUrl;
        return this.input;
    }

    getBaseUrl() {
        return this.baseUrl;
    }

    getStringsUrl() {
        return this.stringsUrl;
    }

    print(languagestrings, prop) {
        if(Object.prototype.hasOwnProperty.call(languagestrings, prop)) {
            return languagestrings[prop];
        }
        else {
            return prop;
        }
    }

    async requestData(url, options) {
        var response;
        var result;
        var answer = {};

        try {
            //console.log('requesting', url, options);
            response = await fetch(url, options);
            try {
                result = await response.json();
            }
            catch(err) {
                result = '';
            }

            if (!response.ok) {
                if(response.status == 401) {
                    answer = {'status': 'error', 'responseStatus': response.status, 'responseBody': result}
                }
                else {
                    answer = {'status': 'error', 'responseStatus': response.status, 'responseBody': result}
                }
            }
            else {
                answer = {'status': 'ok', 'responseStatus': response.status, 'responseBody': result}
            }
        }
        catch(err) {
            //console.log('catch error', err);
            answer = {'status': 'error', 'responseStatus': 'ECONNRESET', 'responseBody': err};
        }

        return answer;
    }

    /*
    setStrings(input) {
        this.strings = input;
        return this.strings;
    }

    async getStrings() {
        return this.strings;
    }

    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
      */
}

module.exports.Api = Api;